function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14,.99A.99.99,0,0,0,13.01,0H.99A.99.99,0,0,0,0,.99V3.415a.99.99,0,0,0,.99.99h.457a.99.99,0,0,0,.981-.99v-.99H5.789v9.15H5.02a.99.99,0,0,0-.99.981v.454a.99.99,0,0,0,.99.99H8.98a.989.989,0,0,0,.99-.99v-.454a.988.988,0,0,0-.99-.981H8.211V2.425h3.367v.99a.989.989,0,0,0,.978.99h.454a.99.99,0,0,0,.99-.99Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/font.d1fddd9a.svg";
export { SvgComponent as ReactComponent };